import { apiSahClients } from '~constants/api';

import { get } from '~libs/genericAction';
import { createThunks } from '~libs/reduxUtils';

export const typePrefix = `clients-with-budgets`;

const config = [{ actionType: 'getAll', apiPath: `${apiSahClients}/budgets/clients`, method: get }];

export const { getAll, getByClient } = createThunks(typePrefix, config);
